import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const initialState = {
  employeeCount: {},
  clientCount: {},
}

export const fetchClientCount = createAsyncThunk('dashboard/clientcount', async () => {
  const response = await AxiosClient.get('/institute-list')
  // console.log("data dev",response)
  return response
})
const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers () {
    // builder
    // .addCase(fetchTomorrowsandTodaysBirthdays.fulfilled, (state, action) => {
    // // state.todayTomorrowData = action.payload
    //   return state
    // })
    // .addCase(fetchMonthlyWeeklyBirthdays.fulfilled, (state, action) => {
    //   state.monthlyWeeklyData = action.payload
    //   return state
    // })
    // .addCase(fetchClientCount.fulfilled, (state, action) => {
    //   state.clientCount = action.payload
    //   return state
    // })
    // .addCase(fetchEmpCount.fulfilled, (state, action) => {
    //   state.employeeCount = action.payload
    //   return state
    // })
    // .addCase(fetchProjectCount.fulfilled, (state, action) => {
    //   state.projectCount = action.payload
    //   return state
    // })
    // .addCase(fetchUpcomingholidays.fulfilled, (state, action) => {
    //   state.holidayData = action.payload
    //   return state
    // })
    // .addCase(fetchTomorrowsandTodaysWorkAnniversary.fulfilled, (state, action) => {
    //   state.todayTomorrowAniversery = action.payload
    //   return state
    // })
    // .addCase(fetchMonthlyWeeklyWorkAnniversary.fulfilled, (state, action) => {
    //   state.monthlyWeeklyAniversery = action.payload
    //   return state
    // })
    // .addCase(fetchConfirmationDate.fulfilled, (state, action) => {
    //   state.confirmationDate = action.payload
    //   return state
    // })

  }
})
export default dashboardSlice.reducer

